export enum ViewNames {
  detailCompany = 'detail-company',
  detailCompanyChanged = 'detail-company-changed',
  detailContact = 'detail-contact',
}
